export const MAX_FIRSTNAME_LENGTH = 50;
export const MAX_LASTNAME_LENGTH = 50;
export const MAX_PHONE_NUMBER_LENGTH = 14;
export const MAX_EMAIL50_LENGTH = 50;
export const MAX_FULLNAME_LENGTH = 100;
export const MAX_MESSAGE_LENGTH = 300;
export const MAX_COMPANY_NAME_LENGTH = 300;
export const MAX_EMAIL320_LENGTH = 320;